import dmPortalConfig from '@dm-portal/config';
import domain from '@framework/config/domain';
import buildUrl from '@framework/url/helpers/buildUrl';
import base from '@framework/url/baseUrl';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';

export default {
  getUrl(...uris: (string | string[])[]): string {
    return buildUrl(domain.protocol, `${ domain.managerDomain }`, ...uris);
  },

  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    return base.getRpcUrl();
  },

  getInternalRpcUrl(): string {
    return `${ dmPortalConfig.api.internal }/rpc`;
  },
};
